import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type ThemeMode = 'light' | 'dark';
export interface ThemeState { mode: ThemeMode }

export function readStoredTheme(): ThemeState {
  try {
    const stored = JSON.parse(localStorage.getItem('qcdoc-theme') ?? 'null')?.state;
    return { mode: stored?.mode === 'dark' ? 'dark' : 'light' };
  } catch {
    return { mode: 'light' };
  }
}

const themeSlice = createSlice({
  name: 'common/theme',
  initialState: readStoredTheme,
  reducers: {
    setMode(state, action: PayloadAction<ThemeMode>) { state.mode = action.payload; },
    toggle(state) { state.mode = state.mode === 'light' ? 'dark' : 'light'; },
    patch(state, action: PayloadAction<Partial<ThemeState>>) { Object.assign(state, action.payload); },
  },
});

export const themeActions = themeSlice.actions;
export default themeSlice.reducer;